import { createGlobalStyle } from 'styled-components'

import breakpoints from './primaryTheme/breakpoints'

const GlobalStyle = createGlobalStyle`
  :root {
    interpolate-size: allow-keywords;
    --dir-multiplier: 1;
    --dir-mirroring-degree: 0deg;

    /* Stacking layers — change here, not with one-off numbers in components */
    --z-index-top-bar: 3;
    --z-index-modal-base: 4;
    --z-index-modal-popup: 5;
  }

  :root[dir="rtl"] {
    --dir-multiplier: -1;
    --dir-mirroring-degree: 180deg;
  }
    
  input[type="password"]::-ms-reveal,
  {
    display: none;
  }

  html,
  body{    
    padding: 0;
    margin: 0;
    font-family: 'Lexend', sans-serif;
    color: ${(props) => props.theme.colors.text.primary};
    background-color: ${(props) => props.theme.colors.bg.dividerLine};
    overscroll-behavior: none;
  }
  body {
    height: 100%;
    position: relative;
  }
  p {
    margin-block: 0;
    text-size-adjust: none;
    -webkit-text-size-adjust: none;
    -ms-text-size-adjust: none;
    -moz-text-size-adjust: none;
  }
  #root {
    height: 100%;
  }

  #navbar-root {
    position: fixed;
    display: flex;
    flex-direction: column;
    bottom: 0;
    insetInlineStart: 0;
    width: 100%;
    z-index: var(--z-index-top-bar);
    box-shadow: 0px -19px 71px rgba(0, 23, 233, 0.15);
  }

  @media (max-width: ${breakpoints.md}) {
    #navbar-root {
      border-top: 1px solid;
      border-color: ${(props) => props.theme.colors.bg.dividerLine};
    }
  }

  #navbar-root > .mobile-cart-tab {
    animation-delay: 2.25s;
    animation: slideUp 0.45s ease-out;
  }

  ::-webkit-scrollbar-thumb {
      border-radius: 1.375rem;
      background-color: ${(props) => props.theme.colors.bg.scrollBar};
  }
  ::-webkit-scrollbar {
      width: 0.375rem;
      background: linear-gradient(186deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.2) 100%);
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes dialog-animation {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }


  @-webkit-keyframes hvr-ripple-out {
    from {
      border:4px solid #6A98F2;
      opacity: 1;
    }
    to {
      top: -12px;
      insetInlineEnd: -12px;
      bottom: -12px;
      insetInlineStart: -12px;
      border-color: transparent;
      opacity: 0;
    }
  }
  @keyframes hvr-ripple-out {
    from {
      border:4px solid #6A98F2;
      opacity: 1;
    }
    to {
      top: -12px;
      insetInlineEnd: -12px;
      bottom: -12px;
      insetInlineStart: -12px;
      border-color: transparent;
      opacity: 0;
    }
  }
  
  @-webkit-keyframes slide-from-side {
    from {
      transform: translate(calc(var(--dir-multiplier) * 100%), 0);
    }
    to {
      transform: translate(0, 0);
    }
  }

  @-webkit-keyframes slide-from-bottom {
    from {
      transform: translate(0, 100%);
    }
    to {
      transform: translate(0, 0);
    }
  }
`

export default GlobalStyle
